import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Helmet } from 'react-helmet';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Helmet>
      <title>Justin D Whitaker</title>
    </Helmet>
    <App />
  </React.StrictMode>
);
